import React, { useRef } from "react";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";

const AddCommunication = ({ note, onSave, onClose }) => {
  const textRef = useRef();
  return (
    <Box sx={{ width: 500 }} mt={2}>
      <Box
        px={2}
        sx={{ backgroundColor: "#dedede" }}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography fontSize={18} color="text.secondary">
          Note
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box sx={{ backgroundColor: "#fff" }}>
        <TextField inputRef={textRef} multiline minRows={5} fullWidth />
      </Box>
      <Box my={2} display={"flex"} gap={2}>
        <Button
          variant="outlined"
          startIcon={<SaveIcon />}
          onClick={() => onSave(textRef.current?.value || "")}
        >
          Save
        </Button>
        <Button onClick={onClose}>Cancel</Button>
      </Box>
    </Box>
  );
};
export default AddCommunication;
